<app-i18n-dictionary xmlns="http://www.w3.org/1999/html">
    <span [attr.transid]="titleTextId" i18n="@@contact_title">Contact us</span>
</app-i18n-dictionary>


<div class="container">
    <div class="col black">
        <div class="title" i18n="@@contact_title">Contact us</div>
    </div>

    <div class="col text">
        <app-cms-block blockId="contact_content"></app-cms-block>
    </div>
</div>
